import {
  CheckboxInput,
  CustomTextArea,
  FormContainer,
  Input,
} from "../../components/inputs";
import { Field, Form } from "react-final-form";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "../../components/button";
import { Grid } from "../../components/section";
import { Text } from "../../components/typography";
import arrayMutators from "final-form-arrays";
import styled from "styled-components";

export const VideoForm = (props) => {
  const { onFormSubmit, initialValues } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const onCloseandReset = (reset) => {
    reset();

    const direction = location.pathname.split("/").includes("edit")
      ? navigate(-1, { replace: true })
      : navigate("/gallery", { replace: true });
    return direction;
  };

  return (
    <Form
      onSubmit={onFormSubmit}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({
        handleSubmit,
        pristine,
        submitting,
        invalid,
        form: {
          mutators: { push },
          reset,
        },
      }) => (
        <form onSubmit={handleSubmit}>
          <Grid col="l15">
            <div>
              <FormContainer>
                <Field
                  name="title"
                  type="text"
                  component={Input}
                  label="Title"
                  placeholder="What is the video title?"
                />
              </FormContainer>
              <FormContainer>
                <Field
                  name="description"
                  label="Describe the video."
                  component={CustomTextArea}
                />
              </FormContainer>
              <FormContainer>
                <Field name="url" type="url" component={Input} label="URL" />
              </FormContainer>

              <FormContainer>
                <Field
                  label="Featured"
                  name="featured"
                  type="checkbox"
                  component={CheckboxInput}
                />
              </FormContainer>
            </div>
          </Grid>
          <ButtonFlex>
            <Text scale="small" onClick={() => onCloseandReset(reset)}>
              Cancel
            </Text>
            <Button
              type="submit"
              disabled={submitting || pristine || invalid}
              text={submitting ? "Saving..." : "Save"}
            />
          </ButtonFlex>
        </form>
      )}
    </Form>
  );
};

const ButtonFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  a:link,
  p,
  button {
    margin: 0;
    cursor: pointer;
  }
`;
